import { render, staticRenderFns } from "./InstallCertificate.vue?vue&type=template&id=13b72286"
import script from "./InstallCertificate.vue?vue&type=script&lang=js"
export * from "./InstallCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports